import { Button } from "@devhop/ui";
import { PlusIcon, ShieldCheck } from "lucide-react";

type ShopRolesToolbarProps = {
  canCreate: boolean;
  canSeed: boolean;
  onSeed: () => void;
  onCreate: () => void;
  seedLoading?: boolean;
};

export function ShopRolesToolbar({
  canCreate,
  canSeed,
  onSeed,
  onCreate,
  seedLoading = false,
}: ShopRolesToolbarProps) {
  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <h2 className="font-bold text-2xl tracking-tight">ບົດບາດ</h2>
          <p className="text-muted-foreground">
            ຈັດການບົດບາດແລະສິດການເຂົ້າເຖິງຂອງພະນັກງານໃນລາຍການ.
          </p>
        </div>
        <div className="flex items-center gap-2">
          {canSeed && (
            <Button
              variant="outline"
              onClick={onSeed}
              disabled={seedLoading}
            >
              {seedLoading ? null : <ShieldCheck className="size-4" />}
              <span className="ml-2">
                ສ້າງຄ່າເລີ່ມຕົ້ນ (Owner, Manager, Cashier)
              </span>
            </Button>
          )}
          {canCreate && (
            <Button onClick={onCreate}>
              <PlusIcon className="size-4" />
              ເພີ່ມບົດບາດ
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
